import { requestManager } from '../../requestManager';

import { API_PATH } from '../../config/config';

class SelectTime {
  /**
   * 1日分の情報を取得する
   * @param {string} lgCd 市町村コード
   * @param {string} date 日付
   * @param {number} rsvSetId 予約設定ID
   * @return {Promise<Array>} 1日分の情報
   */
  getDayInfo = async (lgCd, date, rsvSetId) => {
    const result = await requestManager.post(`${API_PATH}/selecttime/r`, { lgCd, date, rsvSetId });
    return result.data;
  };
}

export default new SelectTime();
